export enum UserSource {
  Facebook = 1,
  Twitter = 2,
  LinkedIn = 3,
  Google = 4,
  Friends = 5,
  Other = 6,
}
